module.exports = __webpack_public_path__ + "media/images/partner/supporter/wpmbb-a820a38efa54309a507daa52f6d0e4ba.png";